// export const DEFAULT_URL = 'http://localhost:5000/';
//PROD
export const DEFAULT_URL = 'http://skycommercesoft.com:5000/';

